<div class="wrapper">
  <div class="nav" [class.nav--narrow]="isNarrowDisplay">
    <div>
      <div class="section" [class.nav--narrow]="isNarrowDisplay">
        <img
          alt="TinQE logo"
          width="48px"
          height="48px"
          src="/assets/images/tinqe-e.png"
        />
        @if (!isNarrowDisplay) {
          <header class="nav__header" [class.nav--narrow]="isNarrowDisplay">
            <h5 class="nav__header--brand">TinQE</h5>
            <h6 class="nav__header--name">
              {{ portal | translate }}
            </h6>
          </header>
        }
      </div>

      <tnq-divider />

      <tnq-nav-list
        [navItems]="navList()"
        [isNarrowDisplay]="isNarrowDisplay"
      ></tnq-nav-list>
    </div>
    <div class="nav__footer" [class.nav--narrow]="isNarrowDisplay">
      <div class="settings section" [class.settings--narrow]="isNarrowDisplay">
        <sui-icon-button
          radius="medium"
          variant="ghost"
          size="md"
          iconName="sun-solar"
          [suiTooltip]="
            themeService.darkMode()
              ? ('navigation.light_mode' | translate)
              : ('navigation.dark_mode' | translate)
          "
          (click)="themeService.setDarkMode(!themeService.darkMode())"
        ></sui-icon-button>
        <sui-icon-button
          radius="medium"
          variant="ghost"
          size="md"
          [suiTooltip]="
            isNarrowDisplay
              ? ('navigation.expand' | translate)
              : ('navigation.collapse' | translate)
          "
          [iconName]="isNarrowDisplay ? 'expand' : 'collapse'"
          (click)="toggleNavDisplaySize()"
        ></sui-icon-button>
      </div>

      <tnq-divider />

      <div class="user section" [class.user--narrow]="isNarrowDisplay">
        @if (!isNarrowDisplay) {
          <div class="user__container">
            <div class="user__image">
              <sui-icon name="user" size="md"></sui-icon>
            </div>
            <div class="user__details" [class.nav--narrow]="isNarrowDisplay">
              <div class="user__details--name">
                {{ currentUser().name || '-' }}
              </div>
              <div class="user__details--role">
                {{
                  'roles.' + currentUser().roles[0].toLocaleLowerCase()
                    | translate
                }}
              </div>
            </div>
          </div>
        }
        <div [class.nav--narrow]="isNarrowDisplay">
          <sui-icon-button
            radius="medium"
            variant="ghost"
            size="md"
            iconName="logout"
            [suiTooltip]="'navigation.logout' | translate"
            (click)="logout()"
          ></sui-icon-button>
        </div>
      </div>
    </div>
  </div>
  <div class="root" [class.root--narrow]="isNarrowDisplay">
    <router-outlet> </router-outlet>
  </div>
</div>
